import React from 'react';

export function TemplateCrudCards() {
  return(
    <>
    </>
  );
}